"use strict";

/*
// Scroll down arrow
// operate the entire functionality if it's on a desktop

if($(window).width() > 881 && $('body.in-sitecore').length == 0){
	
	var headerOffset = $(".header__nav-main-list").offset().top + $(".header__nav-main-list").height();
	var contentHeight = $("footer").offset().top + $("footer").height();
			
	//add the div to the page on load
	$("body").append("<div class='scrollarrow'><div class='scrollarrow__wrapper'><p class='downarrow'>scroll to more content</p><svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='/dist/assets/svg-sprite.svg#downarrow'></use></svg></div></div>");

	function pulse() {
        // This will make sure the button only animates 
        // when the user is at the top of the page
		
        if ($(window).scrollTop() <= headerOffset) {
			//if the window isn't log enough to need this box, hide it.
			if(contentHeight < 1500){
				$('.scrollarrow').clearQueue();
				$('.scrollarrow').css("display", "none");
			} else {
				$('.downarrow, .scrollarrow svg').fadeTo(400,1).fadeTo(600, 0.6, pulse );
				$('.scrollarrow').fadeIn("slow");
			}
        }
		
    }
	// This will trigger the animation on when document is ready
    setTimeout(pulse, 3000);
	

    $(window).scroll(function(){              
        if ($(this).scrollTop() > headerOffset) {
            // This will stop the animation
            $('.scrollarrow').clearQueue();
            // This will hide the bar
            $('.scrollarrow').fadeOut("slow");
        }else{
            $('.scrollarrow').clearQueue();
            // This will restart the animation when the user scrolls back to the top of the page
            setTimeout(pulse, 5000);
        } 
    });
	
	
};
*/
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJFOi9KZW5rL0pvYnMvQ0QxLVByZXAvV29ya3NwYWNlL3dlYi9XZWJzaXRlL2pzL2FvcGEvc2Nyb2xsZG93bmFycm93L3Njcm9sbGRvd25hcnJvdy5qcyIsInNvdXJjZXNDb250ZW50IjpbXX0=